export const inputValidation = (value: string | number, digits = 2) => {
    if (String(value)[0] === '0' && String(value).replace(',', '.')[1] !== '.') {
        return parseFloat(String(value))
    }

    let replacedValue = String(value).replace(',', '.').replace(/[^\d*.?\d*]/g,'');
    const isChanged = replacedValue !== value.toString()

    if (String(replacedValue).indexOf('.') !== -1) {
        replacedValue = replacedValue.substring(0, String(replacedValue).indexOf('.') + digits + 1)
    }

    return isChanged ? replacedValue.replace('.', ',') : replacedValue;
}
